import CurrencyForm from './CurrencyForm'

const Create = () => {
    return (
        <CurrencyForm
            config={{
                submitSuccessMsg: {
                    header: 'Created',
                    message: 'Currency created successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to create currency',
                },
                saveButton: {
                    label: 'Create',
                    savingLabel: 'Creating currency...',
                },
            }}
        />
    )
}

export default Create
